import styled from "styled-components/native";

/**
 * Image that uses the full width and height of the parent container.
 * 
 * Usually used for background images.
 */
const BackgroundImage = styled.Image`
  position: absolute;
  width: 100%;
  height: 100%;
  resizeMode: cover;
`;

export default BackgroundImage;
